export const GET_BOOKMARK = 'GET_BOOKMARK';
export const ADD_BOOKMARK = 'ADD_BOOKMARK';
export const PUT_BOOKMARK = 'PUT_BOOKMARK';
export const DEL_BOOKMARK = 'DEL_BOOKMARK';

export const GET_BOOKMARKS = 'GET_BOOKMARKS';
